<template>
  <div>
    <div class="section-header">Error alert</div>
    <p class="help">Notify on critical failures.</p>
    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field label="Notification service">
          <b-select v-model="formNotificationService.notificationService.error" expanded>
            <option :value="null">None</option>
            <option
              v-for="notificationService in notificationServices"
              :value="notificationService"
              :key="notificationService.alias">
              {{ notificationService.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-6" v-for="configOption in (formNotificationService.notificationService.error && formNotificationService.notificationService.error._id && formNotificationService.notificationService.error.notificationConfig) || []">
        <b-field :label="configOption.name">
          <b-select expanded v-model="formNotificationService.notificationServiceConfig.error[configOption.key]" required>
            <option
              v-for="(value, key) in configOption.options"
              :value="key"
              :key="key">
              {{ value }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>


    <hr>

    <div class="section-header">Warning alert</div>
    <p class="help">Notify on non-critical issues.</p>
    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field label="Notification service">
          <b-select v-model="formNotificationService.notificationService.warning" expanded>
            <option :value="null">None</option>
            <option
              v-for="notificationService in notificationServices"
              :value="notificationService"
              :key="notificationService.alias">
              {{ notificationService.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-6" v-for="configOption in (formNotificationService.notificationService.warning && formNotificationService.notificationService.warning.notificationConfig) || []">
        <b-field :label="configOption.name">
          <b-select expanded v-model="formNotificationService.notificationServiceConfig.warning[configOption.key]" required>
            <option
              v-for="(value, key) in configOption.options"
              :value="key"
              :key="key">
              {{ value }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>

    <hr>

    <div class="section-header">Test Result alert</div>
    <p class="help">Notify after each test with its result.</p>
    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field label="Notification service">
          <b-select v-model="formNotificationService.notificationService.testResult" expanded>
            <option :value="null">None</option>
            <option
              v-for="notificationService in notificationServices"
              :value="notificationService"
              :key="notificationService.alias">
              {{ notificationService.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-6" v-for="configOption in (formNotificationService.notificationService.testResult && formNotificationService.notificationService.testResult._id && formNotificationService.notificationService.testResult.notificationConfig) || []">
        <b-field :label="configOption.name">
          <b-select expanded v-model="formNotificationService.notificationServiceConfig.testResult[configOption.key]" required>
            <option
              v-for="(value, key) in configOption.options"
              :value="key"
              :key="key">
              {{ value }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>


import NotificationServicesService from "@/services/NotificationServicesService";

export default {
  name: 'Alert',
  data () {
    return {
      formNotificationService: {},
      notificationServices: [],
      emptyNotificationService: { notificationConfig: {} }
    }
  },

  methods: {
    getNotificationServices() {
      NotificationServicesService.getList()
        .then(response => {
          this.notificationServices = response.data
        })
    },
  },

  created() {
    this.getNotificationServices()
    this.formNotificationService = this.$store.getters['testType/formNotificationService'];
  }
}
</script>
